import React, { useCallback, useRef } from "react";
import "./ConditionSearch.less";
import IconFont from "@/components/icon";
import { Checkbox } from "antd";
import { SearchGlobalContext } from "./utils";
import TypeSelect from "@/components/Work/BaseComponents/TypeSelect";
import { timeList, timeSlot } from "./ConditionSearch";
import { TASK_STATUS } from "@/types/newWork";
import i18n from "@/i18n";

const taskStatusList = [
  { label: i18n.t("project:task_undone"), value: TASK_STATUS.UNDONE },
  { label: i18n.t("project:task_abort"), value: TASK_STATUS.ABORT },
  { label: i18n.t("project:task_finished"), value: TASK_STATUS.FINISHED }
];

// eslint-disable-next-line complexity
export function ConditionSearchTaskItem({
  t,
  onClose,
  setTaskPriorityType,
  setTaskStatus,
  ConditionVisible,
  setTaskDeadlineTime
}: {
  t: any;
  ConditionVisible: boolean;
  onClose: Function;
  setTaskPriorityType: Function;
  setTaskStatus: Function;
  setTaskDeadlineTime: Function;
}) {
  const { types, taskStatus, taskDeadlineTime, taskPriorityType } = React.useContext(
    SearchGlobalContext
  );
  const childRef:any = useRef(null);

  // 清除操作
  const handleClear = useCallback(
    (type) => {
      switch (type) {
        case "clearAll":
          setTaskStatus([]);
          setTaskPriorityType([]);
          setTaskDeadlineTime(undefined);
          childRef.current?.resetAllSelectStatus();
          break;
        case "taskStatus":
          setTaskStatus([]);
          break;
        case "taskDeadlineTime":
          setTaskDeadlineTime(undefined);
          break;
        case "taskPriorityType":
          setTaskPriorityType([]);
          childRef.current?.resetAllSelectStatus();
          break;
        default:
          break;
      }
    },
    [setTaskDeadlineTime, setTaskPriorityType, setTaskStatus]
  );

  return (
    <div className="ConditionSearchItem">
      <div className="SearchItem_type">
        <header>
          <h3
            className={`${
              taskStatus?.length || taskDeadlineTime || taskPriorityType?.length ? "Highlight" : ""
            }`}
          >
            <IconFont type="iconpc_ic_tjshaixuan_search" style={{ marginRight: 3 }} />
            {taskStatus?.length || taskDeadlineTime || taskPriorityType?.length
              ? "已启用筛选"
              : t("Condition.conditional filtering")}
          </h3>
          <div className="onClear">
            {(!!taskStatus?.length || taskDeadlineTime || !!taskPriorityType?.length) && (
              <>
                <span
                  className="text"
                  onClick={() => {
                    handleClear("clearAll");
                  }}
                >
                  {t("Condition.clearAll")}
                </span>
                <div className="line" />
              </>
            )}
            <IconFont
              type="iconic_pc_im_deletee"
              onClick={() => {
                onClose();
              }}
            />
          </div>
        </header>
        <div className="SearchItem_title">
          <h4>{t("Condition.task status")}</h4>
          {!!taskStatus?.length && (
            <span
              className="del"
              onClick={() => {
                handleClear("taskStatus");
              }}
            >
              {t("Condition.clear")}
            </span>
          )}
        </div>
        <div className="SearchItem_deadlineTime_list_item">
          <Checkbox.Group
            value={taskStatus}
            onChange={(v) => {
              setTaskStatus(v);
            }}
          >
            {taskStatusList?.map((item: { label: string; value: TASK_STATUS }, index: number) => (
              <Checkbox
                className={index % 2 === 0 ? "even" : "odd"}
                key={"deadlineTime-" + index}
                value={item.value}
              >
                {item.label}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </div>
        <div className="SearchItem_title">
          <h4>{t("Condition.deadline time")}</h4>
          {taskDeadlineTime && (
            <span
              className="del"
              onClick={() => {
                handleClear("taskDeadlineTime");
              }}
            >
              {t("Condition.clear")}
            </span>
          )}
        </div>
        <div className="SearchItem_deadlineTime_list_item">
          {timeList?.map((item: { label: string; value: timeSlot }, index: number) => (
            <Checkbox
              className={index % 2 === 0 ? "even" : "odd"}
              key={"deadlineTime-" + index}
              value={item.value}
              checked={item.value === taskDeadlineTime}
              onChange={(e: any) => {
                if (e?.target?.value === taskDeadlineTime) {
                  setTaskDeadlineTime(undefined);
                } else {
                  setTaskDeadlineTime(e?.target?.value);
                }
              }}
            >
              {item.label}
            </Checkbox>
          ))}
        </div>
        <div className="SearchItem_title">
          <h4>{t("Condition.type")}</h4>
          {!!taskPriorityType?.length && (
            <span
              className="del"
              onClick={() => {
                handleClear("taskPriorityType");
              }}
            >
              {t("Condition.clear")}
            </span>
          )}
        </div>
        <div className="SearchItem_type_item">
          <TypeSelect
            ref={childRef}
            defaultChecked={taskPriorityType}
            defaultAllChecked={false}
            onCheckboxChange={(num: number[]) => {
              setTaskPriorityType(num);
            }}
            type="checkbox"
            isCreate={true}
          />
        </div>
      </div>
    </div>
  );
}
